import {
  Box,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { GlobeIcon } from '@phosphor-icons/react';
import { SUPPORTED_LANGUAGES } from '@act/shared/constants';
import { useMobile } from '@act/utilities/MobileContext';

interface LanguageSelectorUIProps {
  value: string;
  onChange: (value: string) => void;
}

export const LanguageSelectorUI = ({
  value,
  onChange,
}: LanguageSelectorUIProps) => {
  const { isMobile } = useMobile();

  return (
    <Box sx={{ padding: isMobile ? '16px 20px' : '0' }}>
      <Select
        variant="standard"
        value={value}
        size="small"
        disableUnderline
        sx={{
          color: '#40484B',
          width: '75px',
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            paddingTop: '8px !important',
            paddingBottom: '8px !important',
            minHeight: 'unset !important',
            '&:focus': {
              outline: 'none !important',
            },
          },
          '& .MuiSelect-icon': {
            color: '#40484B',
            alignSelf: 'center',
            marginTop: '0px !important',
          },
          '& .MuiInputAdornment-root': {
            marginTop: '0px !important',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
          },
          outline: 'none !important',
        }}
        startAdornment={
          <InputAdornment position="start">
            <GlobeIcon
              size={24}
              color="#021E38"
              weight="regular"
              style={{ display: 'block' }}
            />
          </InputAdornment>
        }
        MenuProps={{
          PaperProps: {
            sx: {
              width: '150px',
            },
          },
        }}
        renderValue={value => {
          return value.toLocaleUpperCase() as React.ReactNode;
        }}
        onChange={(event: SelectChangeEvent<string>) =>
          onChange(event.target.value)
        }
      >
        {SUPPORTED_LANGUAGES.map(option => (
          <MenuItem key={option.code} value={option.code}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
